import {
	APP_DESCRIPTION,
	APP_NAME,
	APP_PRODUCTION_URL,
	BASE_URL,
} from "./constants"

export const generateMeta = ({
	title,
	description,
	canonical,
	image,
}: {
	title?: string
	description?: string
	canonical?: string
	image?: string
} = {}) => {
	const siteUrl =
		process.env.NODE_ENV === "production" ? APP_PRODUCTION_URL : BASE_URL

	const metaTitle = title ?? APP_NAME
	const metaDescription = description ?? APP_DESCRIPTION
	const metaImage = image ?? `${siteUrl}/og-image.png`

	return [
		{
			title: metaTitle,
		},
		{
			name: "description",
			content: metaDescription,
		},
		{
			tagName: "link",
			rel: "canonical",
			href: canonical
				? `${canonical?.startsWith("https") ? canonical : `${siteUrl}${canonical}`}`
				: siteUrl,
		},
		{ property: "og:title", content: metaTitle },
		{ property: "og:description", content: metaDescription },
		{ property: "og:image", content: metaImage },
		{ property: "og:type", content: "website" },
		{ property: "og:url", content: canonical ?? siteUrl },
		{ property: "og:site_name", content: APP_NAME },
		{ name: "twitter:card", content: "summary_large_image" },
		{ name: "twitter:title", content: metaTitle },
		{ name: "twitter:description", content: metaDescription },
		{ name: "twitter:image", content: metaImage },
	]
}
